'use client';

import BoxedHeadline from '@/storyblok/wirfuersklima/functionalComponents/BoxedHeadline';
import { HeadlineTag } from '@/storyblok/wirfuersklima/functionalComponents/HeadlineField';
import ContentSection from '@/storyblok/wirfuersklima/functionalComponents/contentSection/ContentSection';
import type { SectionConclusionStoryblok } from '@/storyblok/wirfuersklima/types';
import classNames from 'classnames';
import type { Action } from 'lottie-react';
import dynamic from 'next/dynamic';
import { useInView } from 'react-intersection-observer';

import classes from './SectionConclusion.module.scss';

const LottieAnimation = dynamic(() =>
  import('@/storyblok/wirfuersklima/functionalComponents/LottieAnimation').then((mod) => mod.LottieAnimation)
);

const SectionConclusion: React.FC<{ blok: SectionConclusionStoryblok }> = ({ blok }) => {
  const { ref, inView, entry } = useInView({ threshold: 0 });
  const { ref: refLotti, inView: inViewLotti } = useInView({ triggerOnce: true, rootMargin: '200px 0px' });
  const frameCount = Number(blok.animation_frames);

  const animationOutro = inView || (entry?.boundingClientRect.top ?? 1) <= 0;

  const lottieActions: Action[] = [
    {
      visibility: [0.25, 0.5],
      type: 'seek',
      frames: [0, Math.max(0, frameCount - 1)],
    },
  ];

  return (
    <ContentSection
      blok={blok}
      className={classNames(classes['section-conclusion'], { 'animation-outro': animationOutro })}
      anchorId={blok.anchor_id}
    >
      <BoxedHeadline tag={HeadlineTag.H2} headline={blok.headline} />
      <div ref={refLotti} className={classes['section-conclusion__animation']}>
        {inViewLotti && (
          <LottieAnimation
            path={blok.animation.filename || undefined}
            frames={frameCount}
            actions={lottieActions}
            renderer="canvas"
            aspectRatio="1920 / 1050"
          />
        )}
      </div>
      <div ref={ref} className={classes['section-conclusion__footer']}></div>
    </ContentSection>
  );
};

export default SectionConclusion;
